module.exports = __webpack_public_path__ + "static/media/Dhaka_University_logo.ab0e484a.png";